import React from 'react'
import { Modal, ModalHeader, ModalFooter, Form, ModalBody, Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';

export const ModalAnalizerInterfaces = (props) => {

    const {
        modal, toggle, loading,
        handleInputChange, appCode, saveUpdate, closeDialog
    } = props;
    
    return (
        <Dialog 
            header="Editar App Code"
            visible={modal} 
            onHide={toggle} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
        >
            <Form className='' role="form" onSubmit={saveUpdate}>
                <div style={{ background: "#fff", borderRadius: "20px", padding: "15px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", border: "1px solid #eef2f7"}}>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }} >
                                    APPCODE anterior <span style={{ color: "#46AFE5" }}> *</span>
                                </Label>

                                <Input
                                    type="text"
                                    name="appCode"
                                    onChange={handleInputChange}
                                    value={appCode}
                                    autoComplete="off"
                                    placeholder="Ej. Transporte refrigerado"
                                    style={{
                                        borderRadius: "14px",
                                        minHeight: "40px",
                                        border: "1px solid #dbe4f0",
                                        paddingLeft: "15px",
                                        fontSize: "14px",
                                        boxShadow: "none"
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            
                <ModalFooter>
                    <Button size='sm' color='primary' type='submit' className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                        Actualizar
                    </Button>
                    <Button size='sm' className='btn-air-light' color='danger' type='button' onClick={toggle}>Cancelar</Button>
                </ModalFooter>
            </Form>
        </Dialog>
    )

}
